export enum enumOperacaoMovimento {
  CREDITADO = 'CREDITADO',
  DEBITADO = 'DEBITADO',
}
